import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  mutations: {
    SET_LIST(state, data) {
      state.list = data ?? [];
    },
  },

  actions: {

    async findAll({ commit }, params = {}) {
      const { data } = await api.get('consultacontratocambio', { params });
      commit('SET_LIST', data);
      return data;
    },

    async findById(_, { id }) {
      if (!id) throw new Error('O ID é obrigatório para a busca.');
      const { data } = await api.get(`consultacontratocambio/${id}`);
      return data;
    },

    async findByContratoId(_, { id }) {
      if (!id) throw new Error('O ID do contrato é obrigatório para a busca.');
      const { data } = await api.get(`consultacontratocambio/id/${id}`);
      return data;
    },

    async create(_, payload) {
      const { data } = await api.post('consultacontratocambio', payload);
      return data;
    },

    async update(_, { id, payload }) {
      if (!id) throw new Error('O ID é obrigatório para a atualização.');
      const { data } = await api.put(`consultacontratocambio/${id}`, payload);
      return data;
    },

    async remove(_, { id }) {
      if (!id) throw new Error('O ID é obrigatório para a remoção.');
      const { data } = await api.delete(`consultacontratocambio/${id}`);
      return data;
    },

    async findDistinct(_, { where } = {}) {
      const { data } = await api.get('consultacontratocambio/distinct', { params: where });
      return data;
    },

    async findDistinctCodigo(_, { codigo }) {
      const { data } = await api.get(`consultacontratocambio/distinct/${codigo}`);
      return data;
    },
  },
};
